import { localPath } from "@nabla/api";

function fragment(): string {
  try { return decodeURIComponent(location.hash.slice(1)); } catch { return ""; }
}

const opened = typeof location === "undefined" ? { path: "", token: "" }
  : { path: location.pathname.replace(/\/$/, ""), token: fragment() };

const query = typeof location === "undefined" ? "" : location.search.slice(1);

const para = typeof location === "undefined" ? null : new URLSearchParams(location.search).get("para");

export const landing = typeof location === "undefined" ? "/" : localPath(para, location.origin);

export function tokenFor(path: string): string | undefined {
  return opened.path === path && opened.token !== "" ? opened.token : undefined;
}

export const queryFor = (path: string): string | undefined => opened.path === path ? query : undefined;
